/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DirectiveEventType = zod.enum(['activated', 'served', 'revoked', 'voided']);

export type DirectiveEventType = zod.input<typeof DirectiveEventType>;
export type DirectiveEventTypeOutput = zod.output<typeof DirectiveEventType>;
